"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.verifyTag = exports.defaultDeprecatedTraceTagsMap = void 0;
var LoggerFactory_1 = require("./utils/LoggerFactory");
var LOG = LoggerFactory_1.LoggerFactory.create('ReporterTracingStandards');
var tracingStandardsWikiLink = 'https://wiki.cvent.com/pages/viewpage.action?spaceKey=RD&title=Tracing+Standards';
/**
 * List of deprecated tracing tags that maps to the correct new tag name as defined in Cvent Tracings Standards.
 * @see {tracingStandardsWikiLink}
 */
exports.defaultDeprecatedTraceTagsMap = {
    accountMappingId: 'account_mapping.id',
    attendeeId: 'core.event.attendee.id',
    eventId: 'core.event.id',
    eventName: 'core.event.name',
    sessionId: 'core.event.session.id',
    sessionName: 'core.event.session.name',
    sessionStatus: 'core.event.session.status',
    contactId: 'core.contact.id',
    inviteeId: 'core.event.invitee.id'
};
/**
 * Verify that the tag is not deprecated.
 * For now, we're only logging a warning but that could change in the future
 */
var verifyTag = function (tagName, options) {
    if (!(options === null || options === void 0 ? void 0 : options.muteDeprecatedTags) && exports.defaultDeprecatedTraceTagsMap[tagName]) {
        LOG.warn("Non-standard tracing tag: ".concat(tagName, " used. Refer to the Cvent Tracing Standards wiki for the correct ") +
            'tag to be used.');
    }
};
exports.verifyTag = verifyTag;
